module.exports = __webpack_public_path__ + "img/a11y-simplificada.cbb4a73b.svg";